module.exports = __webpack_public_path__ + "img/success.8af4525c.png";